import { Deserializable } from '../protocols/deserializable';
import { BankAccount } from '../../views/banking/models/bank-account';
import { PaylineAccount } from '../../views/banking/models/payline-account';
import { PaymentMethodType } from '../shared/payment-method-type';
import { PaymentMethodTypeIdEnum } from '../enum/shared/payment-method-type-id.enum';
import { VariableBenefitAccountDetails } from '../transactions/variable-benefit-account-details';
import { VbTarget } from '../transactions/vb-target';
import { WithdrawalInstruction } from './withdrawal-instruction';

export class VariableBenefitSummary implements Deserializable {
  public memberId!: number;
  public yearToDatePaymentAmount!: number;
  public nextPaymentDate!: string | null;
  public nextPaymentAmount!: number | null;
  public combinedMinimumAnnualWithdrawalAmount!: number | null;
  public combinedEstimatedAnnualPaymentAmount!: number;
  public combinedActiveEstimatedAnnualRecurringPaymentAmount!: number;
  public combinedScheduledEstimatedAnnualRecurringPaymentAmount!: number;
  public currentTarget!: VbTarget | null;
  public scheduledTarget!: VbTarget | null;
  public paymentMethodId!: PaymentMethodTypeIdEnum;
  public paymentMethod!: PaymentMethodType;
  public paymentBankAccountId!: number | null;
  public paymentBankAccount!: BankAccount | null;
  public paymentPaylineAccountId!: number | null;
  public paymentPaylineAccount!: PaylineAccount | null;
  public accountDetails!: VariableBenefitAccountDetails[];
  public withdrawalInstructions!: WithdrawalInstruction[];

  // A scheduled change with no amount ends the target, so it still wins over the target in force
  public plannedTarget(): VbTarget | null {
    return this.scheduledTarget ?? this.currentTarget;
  }

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (this.currentTarget) {
      this.currentTarget = Deserialize.instanceOf(VbTarget, this.currentTarget);
    }

    if (this.scheduledTarget) {
      this.scheduledTarget = Deserialize.instanceOf(VbTarget, this.scheduledTarget);
    }

    if (this.paymentMethod) {
      this.paymentMethod = Deserialize.instanceOf(PaymentMethodType, this.paymentMethod);
    }

    if (this.paymentBankAccount) {
      this.paymentBankAccount = Deserialize.instanceOf(BankAccount, this.paymentBankAccount);
    }

    if (this.paymentPaylineAccount) {
      this.paymentPaylineAccount = Deserialize.instanceOf(PaylineAccount, this.paymentPaylineAccount);
    }

    if (this.accountDetails) {
      this.accountDetails = Deserialize.arrayOf(VariableBenefitAccountDetails, this.accountDetails);
    }

    if (this.withdrawalInstructions) {
      this.withdrawalInstructions = Deserialize.arrayOf(WithdrawalInstruction, this.withdrawalInstructions);
    }
  }
}
